module.exports = __webpack_public_path__ + "static/media/next-icon-ice-cube-o.85d1430d.svg";